<div class="container">
  <cst-toolbar class="toolbar">
    @if (!isFormularLoading && formular?.Bezeichnung) {
      <h1>{{ formular["Bezeichnung"] }}</h1>
    }

    <ctrl-btn-accept (click)="onFormularEditorAccept()"></ctrl-btn-accept>
    <ctrl-btn-cancel (click)="onFormularEditorClose()"></ctrl-btn-cancel>
  </cst-toolbar>

  @if (isDataReady) {
    <div class="formular-wrapper">
      <mat-tab-group>
        @for (tab of tabsArray; track trackByFn(i, tab); let i = $index) {
          <mat-tab label="{{ tab.title }}">
            <app-formular-group-tab
              [data]="withMetadata(tab.data)"
              [form]="tab.ctl"
              [formGroup]="formularForm"
              [tabKey]="tab.formKey"
            ></app-formular-group-tab>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  }
  @if (isFormularLoading) {
    <app-spinner [IsLoading]="true" class="spinner-overlay"></app-spinner>
  }
</div>
